import { useCallback, useState } from "react";
import shortid from "shortid";

export const useArray = (initial: any) => {
  const [values, set] = useState(initial || []);

  const toggle = (value: string) => {
    let _values: string[] = [];
    if (values) {
      _values = [...values];
    }

    const io = _values.indexOf(value);
    if (io !== -1) {
      _values.splice(io, 1);
    } else {
      _values.push(value);
    }

    set(_values);
    return _values;
  };

  return [
    values,
    {
      set,
      toggle,
    },
  ];
};

export const useArrayReducer = <T extends { id: string }>(
  initial: Array<T>,
) => {
  const [values, setValues] = useState(initial);

  const onSet = useCallback(
    (newValues: Array<T>) => {
      setValues(newValues);
    },
    [setValues],
  );

  const onCreate = useCallback(
    (emptyT: Omit<T, "id">) => {
      setValues((values) => [
        ...values,
        {
          ...emptyT,
          id: shortid(),
        } as T,
      ]);
    },
    [setValues],
  );

  const onDelete = useCallback(
    (id: string) => {
      const newValues = values.filter((value) => value.id !== id);
      setValues((values) => newValues);
    },
    [setValues, values],
  );

  const onUpdate = useCallback(
    (id: string, newData: Partial<Omit<T, "id">>) => {
      setValues((holidays) =>
        holidays.map((h) => (h.id === id ? { ...h, ...newData } : h)),
      );
    },
    [setValues],
  );

  return {
    values,
    onSet,
    onCreate,
    onDelete,
    onUpdate,
  };
};
